import React from 'react';
import { Button } from 'reactstrap';
import Text from '../../../../components/Text';

export default function AkoyaView({
  children,
  handleNextClick,
}) {
  return (
    <>
      <div>
        { children }
      </div>
      <Button
        color="success"
        onClick={handleNextClick}
      >
        <Text value="Next" />
      </Button>
    </>
  );
}
